import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import DateFnsUtils from '@date-io/date-fns'

import { serverUrl, headerRequest, corporation } from '../../lib/funApp/general'

import { Card, Col, Container, Row, Modal } from 'react-bootstrap'
import { Button, Icon, Label, Table } from 'semantic-ui-react'
import { MDBIcon } from 'mdbreact'
import { FormControl, Grid, InputLabel, Select, MenuItem, TextField } from '@material-ui/core'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import { toast } from 'react-toastify'
import RecordAdd from './recordAdd'
import RecordDelete from './recordDelete'

export default class PrevisionsList extends Component {
  allowedSettleAccountTypes = ['carteira', 'conta corrente', 'conta poupanca', 'cofre']

  constructor() {
    super()
    this.state = {
      dateIni: moment().startOf('month').format('YYYY-MM-DD hh:mm'),
      dateEnd: moment().endOf('month').format('YYYY-MM-DD hh:mm'),
      dataRecords: [],
      isLoading: false,
      isDisabled: false,
      settlingIds: {},
      dataAccount: [],
      showSettle: false,
      settleRecord: null,
      settleDate: new Date(),
      settleAccount: '',
      settleAccountOrigin: '',
      settleType: 'normal',
      settleHistory: '',
      settleValue: 0,
      dataCategory: [],
      expandedRows: {},
      typeFilter: 'all',
    }
  }

  componentDidMount() {
    this.getRecords()
    this.getAccounts()
    this.getCategories()
  }

  changeDateIni(value) {
    this.setState({ dateIni: value })
  }

  changeDateEnd(value) {
    this.setState({ dateEnd: value })
  }

  changeTypeFilter = (event) => {
    this.setState({ typeFilter: event.target.value })
  }

  getDueStatus = (record) => {
    const dueDate = moment(record && (record.dueDate || record.date))
    if (!dueDate.isValid()) {
      return { label: 'A vencer', color: 'green' }
    }

    const dueDay = dueDate.startOf('day')
    const today = moment().startOf('day')

    if (dueDay.isBefore(today)) {
      return { label: 'Vencido', color: 'red' }
    }

    if (dueDay.isSame(today)) {
      return { label: 'Vence Hoje', color: 'blue' }
    }

    return { label: 'A vencer', color: 'green' }
  }

  getRecurringLabel = (record) => {
    const recurring = String((record && record.recurring) || 'No')
    const labels = {
      Monthly: 'Mensal',
      Biweekly: 'Quinzenal',
      Weekly: 'Semanal',
      FirstDay: 'Primeiro dia do mês',
      LastDay: 'Último dia do mês',
    }
    if (recurring === 'No') {
      return 'Não'
    }
    return labels[recurring] || recurring
  }

  parseInstallment = (record) => {
    const raw = record && record.installment ? String(record.installment) : ''
    const match = raw.match(/^(\d+)\s*\/\s*(\d+)$/)
    if (!match) {
      return null
    }
    const current = Number(match[1])
    const total = Number(match[2])
    if (!Number.isFinite(current) || !Number.isFinite(total) || current < 1 || total < current) {
      return null
    }
    return { current, total }
  }

  getRemainingValue = (records, record) => {
    const installment = this.parseInstallment(record)
    const currentValue = Math.abs(Number(record && record.value ? record.value : 0))
    if (!installment) {
      return currentValue
    }
    return currentValue * (installment.total - installment.current + 1)
  }

  toggleRowExpand = (recordId) => {
    if (!recordId) {
      return
    }
    this.setState((prevState) => ({
      expandedRows: {
        ...prevState.expandedRows,
        [recordId]: !prevState.expandedRows[recordId],
      },
    }))
  }

  getRecords = () => {
    this.setState({ isLoading: true, isDisabled: true })

    const targetUrl =
      serverUrl +
      '/src/records?dtstart=' +
      moment(this.state.dateIni).format('YYYY-MM-DD') +
      '&dtend=' +
      moment(this.state.dateEnd).format('YYYY-MM-DD') +
      '&prevision=only'

    axios
      .get(targetUrl, { headers: headerRequest })
      .then((res) => {
        const items = res && res.data && res.data.items ? res.data.items : []
        const filtered = this.state.typeFilter === 'all'
          ? items
          : items.filter((item) => item.type === this.state.typeFilter)
        const grouped = this.groupRecords(filtered)
        this.setState({ dataRecords: grouped, isLoading: false, isDisabled: false })
      })
      .catch((error) => {
        console.log(error.response || error)
        this.setState({ dataRecords: [], isLoading: false, isDisabled: false })
      })
  }

  normalizeAccountType = (value) => {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
  }

  isCreditCardType = (type) => {
    return this.normalizeAccountType(type) === 'cartao credito'
  }

  isAllowedSettleAccountType = (type) => {
    const normalized = this.normalizeAccountType(type)
    return this.allowedSettleAccountTypes.includes(normalized)
  }

  getAccountById = (accountId) => {
    return this.state.dataAccount.find((account) => String(account && account._id) === String(accountId))
  }

  isCreditCardPrevision = (record) => {
    const accountType = record && record.account ? record.account.type : ''
    return this.isCreditCardType(accountType)
  }

  getSettleAccountOptions = () => {
    if (!this.isCreditCardPrevision(this.state.settleRecord)) {
      return this.state.dataAccount
    }
    return this.state.dataAccount.filter((account) => this.isAllowedSettleAccountType(account && account.type))
  }

  getAccounts = () => {
    const targetUrlAccounts = serverUrl + '/src/accounts'
    axios
      .get(targetUrlAccounts, { headers: headerRequest })
      .then((res) => {
        if (res.status === 200 && res.data && res.data.items) {
          this.setState({ dataAccount: res.data.items })
        }
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  getCategories = () => {
    const targetUrlCategories = serverUrl + '/src/categories'
    axios
      .get(targetUrlCategories, { headers: headerRequest })
      .then((res) => {
        if (res.status === 200 && res.data && res.data.items) {
          this.setState({ dataCategory: res.data.items })
        }
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  handleOpenSettle = (record) => {
    if (!record) {
      return
    }
    // Refresh account balances before showing the settle modal.
    this.getAccounts()
    const defaultAccountId = record.account ? record.account._id : ''
    const isCreditCardPrevision = this.isCreditCardPrevision(record)
    const allowedAccounts = this.state.dataAccount.filter((account) =>
      this.isAllowedSettleAccountType(account && account.type)
    )
    const hasDefaultAllowed = allowedAccounts.some(
      (account) => String(account && account._id) === String(defaultAccountId)
    )
    const nextSettleAccount = isCreditCardPrevision
      ? hasDefaultAllowed
        ? defaultAccountId
        : allowedAccounts.length > 0
          ? allowedAccounts[0]._id
          : ''
      : defaultAccountId
    this.setState({
      showSettle: true,
      settleRecord: record,
      settleDate: new Date(),
      settleAccount: nextSettleAccount,
      settleAccountOrigin: '',
      settleType: 'normal',
      settleHistory: record && record.history ? record.history : '',
      settleValue: record && typeof record.value === 'number' ? Math.abs(record.value) : 0,
    })
  }

  handleCloseSettle = () => {
    this.setState({ showSettle: false, settleRecord: null })
  }

  handleSettleDate = (date) => {
    this.setState({ settleDate: date })
  }

  handleSettleAccount = (event) => {
    this.setState({ settleAccount: event.target.value })
  }

  handleSettleAccountOrigin = (event) => {
    this.setState({ settleAccountOrigin: event.target.value })
  }

  handleSettleType = (event) => {
    this.setState({ settleType: event.target.value })
  }

  handleSettleHistory = (event) => {
    this.setState({ settleHistory: event.target.value })
  }

  handleSettleValue = (values) => {
    const nextValue = values && typeof values.floatValue === 'number' ? values.floatValue : 0
    this.setState({ settleValue: Math.abs(nextValue) })
  }

  normalizeId = (value) => {
    if (value && typeof value === 'object') {
      return value._id || value.id || undefined
    }
    return value
  }

  buildPayloadFromRecord = (record) => {
    const payload = { ...(record || {}) }
    delete payload._id
    delete payload.id
    delete payload.__v
    delete payload._links

    const accountId = this.normalizeId(record && record.account)
    if (accountId) {
      payload.account = accountId
    }

    const corporationId = this.normalizeId(record && record.corporation) || corporation
    if (corporationId) {
      payload.corporation = corporationId
    }

    const personId = this.normalizeId(record && record.person)
    if (personId) {
      payload.person = personId
    } else {
      delete payload.person
    }

    if (Array.isArray(record && record.category)) {
      payload.category = record.category
        .map((item, index) => {
          const categoryId = this.normalizeId(item && item.category)
          return {
            order:
              item && typeof item.order !== 'undefined' && item.order !== null
                ? Number(item.order)
                : index + 1,
            category: categoryId,
            history: item && item.history ? item.history : undefined,
            value: Number(item && item.value ? item.value : 0),
          }
        })
        .filter((item) => item.category)
    }

    const counterpartId = this.normalizeId(record && record.counterpart)
    if (counterpartId) {
      payload.counterpart = counterpartId
    } else {
      delete payload.counterpart
    }

    payload.value = Number(record && typeof record.value !== 'undefined' ? record.value : 0)
    return payload
  }

  settlePrevision = async (recordId) => {
    if (!recordId || this.state.settlingIds[recordId]) {
      return
    }

    const settleRecord = this.state.settleRecord
    if (!settleRecord) {
      return
    }

    const isCreditCardPrevision = this.isCreditCardPrevision(settleRecord)
    if (isCreditCardPrevision) {
      const selectedAccount = this.getAccountById(this.state.settleAccount)
      if (!selectedAccount || !this.isAllowedSettleAccountType(selectedAccount.type)) {
        toast.error(
          'Provisões de cartão só podem ser baixadas em Carteira, Conta Corrente, Conta poupança ou Cofre.'
        )
        return
      }
      if (this.state.settleType === 'transfer') {
        const selectedOriginAccount = this.getAccountById(this.state.settleAccountOrigin)
        if (!selectedOriginAccount || !this.isAllowedSettleAccountType(selectedOriginAccount.type)) {
          toast.error(
            'Na transferência, a Conta Origem também deve ser Carteira, Conta Corrente, Conta poupança ou Cofre.'
          )
          return
        }
      }
    }

    if (
      this.state.settleType === 'transfer' &&
      (!this.state.settleAccountOrigin || this.state.settleAccountOrigin === this.state.settleAccount)
    ) {
      return
    }

    const settlingIds = { ...this.state.settlingIds, [recordId]: true }
    this.setState({ settlingIds })

    const settleDate = this.state.settleDate || new Date()
    const settleAccount = this.state.settleAccount || undefined
    const baseValue = Math.abs(Number(this.state.settleValue) || 0)
    const baseNumber = settleRecord && settleRecord.number ? settleRecord.number : undefined
    const baseHistory = this.state.settleHistory
    const basePayload = this.buildPayloadFromRecord(settleRecord)

    try {
      if (this.state.settleType === 'transfer') {
        const updatePayload = {
          ...basePayload,
          prevision: false,
          dueDate: undefined,
          date: settleDate,
          account: settleAccount || basePayload.account,
          type: 'T',
          value: baseValue,
          history: baseHistory,
        }
        delete updatePayload.person
        updatePayload.category = []
        if (baseNumber) {
          updatePayload.number = baseNumber
        }

        await axios.put(serverUrl + '/src/records/' + recordId, updatePayload, { headers: headerRequest })

        const counterpartPayload = {
          type: 'T',
          date: settleDate,
          account: this.state.settleAccountOrigin,
          value: baseValue * -1,
          prevision: false,
          counterpart: recordId,
        }
        if (baseNumber) {
          counterpartPayload.number = baseNumber
        }
        if (baseHistory) {
          counterpartPayload.history = baseHistory
        }

        const counterpartRes = await axios.post(serverUrl + '/src/records', counterpartPayload, {
          headers: headerRequest,
        })
        const counterpartId = counterpartRes && counterpartRes.data ? counterpartRes.data._id : undefined
        if (counterpartId) {
          await axios.patch(
            serverUrl + '/src/records/' + recordId,
            { counterpart: counterpartId },
            { headers: headerRequest }
          )
        }
      } else {
        const valueSignal = Number(settleRecord && settleRecord.value ? settleRecord.value : 0) < 0 ? -1 : 1
        const updatePayload = {
          ...basePayload,
          prevision: false,
          dueDate: undefined,
          date: settleDate,
          account: settleAccount || basePayload.account,
          history: baseHistory,
          value: baseValue * valueSignal,
        }
        await axios.put(
          serverUrl + '/src/records/' + recordId,
          updatePayload,
          { headers: headerRequest }
        )
      }

      this.handleCloseSettle()
      this.getRecords()
      this.getAccounts()
    } catch (error) {
      console.log(error.response || error)
    } finally {
      const nextIds = { ...this.state.settlingIds }
      delete nextIds[recordId]
      this.setState({ settlingIds: nextIds })
    }
  }

  groupRecords = (records) => {
    const groups = {}

    records.forEach((record) => {
      const accountId = record && record.account && record.account._id ? record.account._id : 'no-account'
      const accountName = record && record.account && record.account.name ? record.account.name : 'Sem conta'
      const personId = record && record.person && record.person._id ? record.person._id : 'no-person'
      const personName = record && record.person && record.person.name ? record.person.name : 'Sem fornecedor'

      if (!groups[accountId]) {
        groups[accountId] = { accountId, accountName, people: {} }
      }

      if (!groups[accountId].people[personId]) {
        groups[accountId].people[personId] = {
          personId,
          personName,
          records: [],
        }
      }

      groups[accountId].people[personId].records.push(record)
    })

    const accounts = Object.values(groups)
    accounts.sort((a, b) => a.accountName.localeCompare(b.accountName))

    return accounts.map((account) => {
      const people = Object.values(account.people)
      people.sort((a, b) => a.personName.localeCompare(b.personName))

      const peopleWithTotals = people.map((person) => {
        const records = person.records
        records.sort((a, b) => {
          const aDate = a && a.dueDate ? new Date(a.dueDate) : new Date(a && a.date ? a.date : 0)
          const bDate = b && b.dueDate ? new Date(b.dueDate) : new Date(b && b.date ? b.date : 0)
          return aDate.getTime() - bDate.getTime()
        })

        const total = records.reduce((sum, item) => sum + Number(item.value || 0), 0)
        const totalReceiver = records.reduce((sum, item) => {
          const v = Number(item.value || 0)
          return sum + (v > 0 ? v : 0)
        }, 0)
        const totalPayable = records.reduce((sum, item) => {
          const v = Number(item.value || 0)
          return sum + (v < 0 ? v : 0)
        }, 0)

        return { ...person, records, total, totalReceiver, totalPayable }
      })

      const total = peopleWithTotals.reduce((sum, person) => sum + person.total, 0)

      return { ...account, people: peopleWithTotals, total }
    })
  }

  getCategoryLabel = (record) => {
    if (!record) {
      return '-'
    }

    if (record.type === 'T') {
      return 'Transferência'
    }

    const categories = Array.isArray(record.category) ? record.category : []
    if (categories.length === 0) {
      return '-'
    }

    if (categories.length > 1) {
      return 'Diversas'
    }

    const category = categories[0] && categories[0].category
    if (category && typeof category === 'object') {
      return category.name || '-'
    }

    if (category) {
      const found = this.state.dataCategory.find((item) => item && item._id === category)
      return found && found.name ? found.name : '-'
    }

    return '-'
  }

  render() {
    const settleAccountOptions = this.getSettleAccountOptions()
    return (
      <>
        <Container>
          <Row className="TitleContainer" style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
            <Col style={{ padding: '10px' }}>
              <h4>
                <MDBIcon icon="calendar-alt" className="mr-2 ml-4" />
                Previsões
              </h4>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end">
              <RecordAdd />
            </Col>
          </Row>
        </Container>

        <Container className="MainContainer" style={{ backgroundColor: 'white', padding: '5px' }}>
          <Row className="mb-3">
            <Col>
              <Card>
                <Card.Body>
                  <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
                    <Grid item xs={12} md={7}>
                      <div className="previsions-filter-row">
                        <FormControl controlid="dateStart">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              margin="normal"
                              id="date-picker-start"
                              label="Início"
                              value={this.state.dateIni}
                              onChange={(e) => this.changeDateIni(e)}
                              format="dd/MM/yyyy"
                              KeyboardButtonProps={{
                                'aria-label': 'Alterar Data',
                              }}
                              className="previsions-date-picker"
                              style={{ marginTop: '0px', width: '150px' }}
                            />
                          </MuiPickersUtilsProvider>
                        </FormControl>
                        <FormControl controlid="dateEnd">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              margin="normal"
                              id="date-picker-end"
                              label="Fim"
                              value={this.state.dateEnd}
                              onChange={(e) => this.changeDateEnd(e)}
                              format="dd/MM/yyyy"
                              KeyboardButtonProps={{
                                'aria-label': 'Alterar Data',
                              }}
                              className="previsions-date-picker"
                              style={{ marginTop: '0px', width: '150px' }}
                            />
                          </MuiPickersUtilsProvider>
                        </FormControl>
                      </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <FormControl style={{ minWidth: '120px' }}>
                        <InputLabel id="type-filter-label">Tipo</InputLabel>
                        <Select
                          labelId="type-filter-label"
                          id="type-filter"
                          value={this.state.typeFilter}
                          onChange={this.changeTypeFilter}
                        >
                          <MenuItem value="all">Ambos</MenuItem>
                          <MenuItem value="R">Receitas</MenuItem>
                          <MenuItem value="D">Despesas</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} md={2} className="text-right">
                      <Button
                        icon
                        labelPosition="left"
                        color={!this.state.isLoading ? 'blue' : 'grey'}
                        disabled={this.state.isDisabled}
                        onClick={this.getRecords}
                      >
                        {!this.state.isLoading ? 'Atualizar' : 'Aguarde'}
                        <Icon name="sync" loading={this.state.isLoading} />
                      </Button>
                    </Grid>
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>

        {this.state.dataRecords.length > 0 ? (
          this.state.dataRecords.map((account) => (
            <Row key={account.accountId} className="mb-3">
              <Col>
                <Card style={{ flexDirection: 'column', display: 'flex' }}>
                  <div
                    className="previsions-account-header"
                    style={{
                      borderLeft: `3px solid ${account.total < 0 ? 'red' : 'green'}`,
                      borderBottom: `3px solid ${account.total < 0 ? 'red' : 'green'}`,
                      backgroundColor: '#fff',
                      padding: '5px 12px',
                      color: `${account.total < 0 ? 'red' : 'green'}`,
                    }}
                  >
                    <span>
                      <strong>{account.accountName}</strong>
                    </span>
                    <span className={account.total < 0 ? 'previsions-account-total text-danger' : 'previsions-account-total'}>
                      <MDBIcon icon="chevron-left" className="mr-2" />
                      <CurrencyFormat
                        value={account.total}
                        displayType={'text'}
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                      <MDBIcon icon="chevron-right" className="ml-2" />
                    </span>
                  </div>
                  <Card.Body>
                    {account.people.map((person) => (
                      <div key={person.personId} className="mb-3">
                        <div className="mb-2 previsions-person-header">
                          <Label color={person.total >= 0 ? 'blue' : 'red'} basic>
                            {person.personName}
                          </Label>
                          {person.totalReceiver !== 0 && person.totalPayable !== 0 && (
                            <>
                              <Label color='blue' basic className="ml-1">
                                <MDBIcon icon="plus-square" className="mr-1 text-primary" />
                                <CurrencyFormat
                                  value={person.totalReceiver}
                                  displayType={'text'}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                  prefix="R$ "
                                />
                              </Label>
                              <Label color='red' basic className="ml-1">
                                <MDBIcon icon="minus-square" className="mr-1 text-danger" />
                                <CurrencyFormat
                                  value={person.totalPayable}
                                  displayType={'text'}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                  prefix="R$ "
                                />
                              </Label>
                            </>
                          )}
                          <Label color={person.total >= 0 ? 'blue' : 'red'} basic className="previsions-person-total">
                            <CurrencyFormat
                              value={person.total}
                              displayType={'text'}
                              thousandSeparator="."
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale={2}
                              prefix="R$ "
                            />
                          </Label>
                        </div>

                        <div className="previsions-table-wrap d-none d-md-block">
                        <Table compact celled className="previsions-table" style={{ width: '100%' }}>
                          <colgroup>
                            <col style={{ width: '150px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '320px' }} />
                            <col style={{ width: '140px' }} />
                            <col style={{ width: '40px' }} />
                          </colgroup>
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell className="text-center" />
                              <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>
                                Vencimento
                              </Table.HeaderCell>
                              <Table.HeaderCell>
                                Categoria
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-right" style={{ whiteSpace: 'nowrap' }}>
                                Valor
                              </Table.HeaderCell>
                              <Table.HeaderCell className="text-center" />
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {person.records.map((record) => {
                              const dueStatus = this.getDueStatus(record)
                              const recurringLabel = this.getRecurringLabel(record)
                              const installmentInfo = this.parseInstallment(record)
                              const remainingValue = this.getRemainingValue(person.records, record)
                              const isExpanded = !!this.state.expandedRows[record._id]
                              return (
                              <React.Fragment key={record._id}>
                                <Table.Row
                                  onClick={() => this.toggleRowExpand(record._id)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <Table.Cell className="text-center">
                                    <Button
                                      icon
                                      size="mini"
                                      labelPosition="left"
                                      color={!this.state.settlingIds[record._id] ? dueStatus.color : 'grey'}
                                      disabled={this.state.isDisabled || !!this.state.settlingIds[record._id]}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        this.handleOpenSettle(record)
                                      }}
                                      style={{ minWidth: '128px' }}
                                    >
                                      <Icon name="check" />
                                      {dueStatus.label}
                                    </Button>
                                  </Table.Cell>
                                  <Table.Cell style={{ whiteSpace: 'nowrap' }}>
                                    {moment((record && (record.dueDate || record.date)) || 0).format('DD/MM/YYYY')}
                                  </Table.Cell>
                                  <Table.Cell style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {this.getCategoryLabel(record)}
                                  </Table.Cell>
                                  <Table.Cell className="text-right" style={{ whiteSpace: 'nowrap' }}>
                                    <CurrencyFormat
                                      value={record.value}
                                      displayType={'text'}
                                      thousandSeparator="."
                                      decimalSeparator=","
                                      fixedDecimalScale={true}
                                      decimalScale={2}
                                      prefix="R$ "
                                    />
                                    <MDBIcon
                                      size="lg"
                                      icon={record.type === 'D' ? 'minus-square' : record.type === 'R' ? 'plus-square' : record.type === 'T' ? 'random' : 'plane'}
                                      className={'ml-2 text-' + (record.type === 'D' ? 'danger' : record.type === 'R' ? 'primary' : record.type === 'T' ? (record.value > 0 ? 'primary' : 'danger') : 'default')}
                                    />
                                  </Table.Cell>
                                  <Table.Cell className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                    <strong style={{ fontSize: '18px', lineHeight: 1 }}>
                                      {isExpanded ? '-' : '+'}
                                    </strong>
                                  </Table.Cell>
                                </Table.Row>
                                {isExpanded ? (
                                <Table.Row>
                                  <Table.Cell colSpan="5" style={{ backgroundColor: '#fafafa' }}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={3}>
                                        <strong>Data Compra:</strong> {moment((record && record.date) || 0).format('DD/MM/YYYY')}
                                      </Grid>
                                      <Grid item xs={12} md={3}>
                                        <strong>Recorrente:</strong> {recurringLabel}
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <strong>Histórico:</strong> {record.history || '-'}
                                      </Grid>
                                    </Grid>
                                    {installmentInfo ? (
                                      <Grid container spacing={2} style={{ marginTop: '4px' }}>
                                        <Grid item xs={12} md={4}>
                                          <strong>Parcela:</strong> {record.installment || '-'}
                                        </Grid>
                                        <Grid item xs={12} md={8}>
                                          <strong>Valor Restante:</strong>{' '}
                                          <CurrencyFormat
                                            value={remainingValue}
                                            displayType={'text'}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            prefix="R$ "
                                          />
                                        </Grid>
                                      </Grid>
                                    ) : false}
                                    <Grid container spacing={2} style={{ marginTop: '8px' }}>
                                      <Grid item xs={12} className="text-right">
                                        <RecordDelete item={record} />
                                      </Grid>
                                    </Grid>
                                  </Table.Cell>
                                </Table.Row>
                                ) : false}
                              </React.Fragment>
                            )})}
                          </Table.Body>
                        </Table>
                        </div>
                        <div className="d-md-none">
                          {person.records.map((record) => {
                            const dueStatus = this.getDueStatus(record)
                            const recurringLabel = this.getRecurringLabel(record)
                            const installmentInfo = this.parseInstallment(record)
                            const remainingValue = this.getRemainingValue(person.records, record)
                            const isExpanded = !!this.state.expandedRows[record._id]
                            return (
                              <Card
                                key={record._id}
                                className="mb-2 previsions-mobile-card"
                                onClick={() => this.toggleRowExpand(record._id)}
                              >
                                <Card.Body className="p-2">
                                  <Row>
                                    <Col xs={12} className="mb-2 d-flex justify-content-between align-items-center">
                                      <span className="text-muted" style={{ fontSize: '12px' }}>
                                        {isExpanded ? 'Ocultar detalhes' : 'Ver detalhes'}
                                      </span>
                                      <strong style={{ fontSize: '18px', lineHeight: 1 }}>
                                        {isExpanded ? '-' : '+'}
                                      </strong>
                                    </Col>
                                    <Col xs={12} className="mb-2">
                                      <Button
                                        icon
                                        size="mini"
                                        labelPosition="left"
                                        color={!this.state.settlingIds[record._id] ? dueStatus.color : 'grey'}
                                        disabled={this.state.isDisabled || !!this.state.settlingIds[record._id]}
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          this.handleOpenSettle(record)
                                        }}
                                      >
                                        <Icon name="check" />
                                        {dueStatus.label}
                                      </Button>
                                    </Col>
                                    <Col xs={6}>
                                      <small className="text-muted d-block">Vencimento</small>
                                      <strong>{moment((record && (record.dueDate || record.date)) || 0).format('DD/MM/YYYY')}</strong>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                      <small className="text-muted d-block">Valor</small>
                                      <strong>
                                        <CurrencyFormat
                                          value={record.value}
                                          displayType={'text'}
                                          thousandSeparator="."
                                          decimalSeparator=","
                                          fixedDecimalScale={true}
                                          decimalScale={2}
                                          prefix="R$ "
                                        />
                                        <MDBIcon
                                          size="lg"
                                          icon={record.type === 'D' ? 'minus-square' : record.type === 'R' ? 'plus-square' : record.type === 'T' ? 'random' : 'plane'}
                                          className={'ml-2 text-' + (record.type === 'D' ? 'danger' : record.type === 'R' ? 'primary' : record.type === 'T' ? (record.value > 0 ? 'primary' : 'danger') : 'default')}
                                        />
                                      </strong>
                                    </Col>
                                    <Col xs={12} className="mt-2">
                                      <small className="text-muted d-block">Categoria</small>
                                      <span>{this.getCategoryLabel(record)}</span>
                                    </Col>
                                    {isExpanded ? (
                                      <Col xs={12} className="mt-2 pt-2 previsions-mobile-details">
                                        <Row>
                                          <Col xs={12} className="mb-1">
                                            <strong>Data Compra:</strong> {moment((record && record.date) || 0).format('DD/MM/YYYY')}
                                          </Col>
                                          <Col xs={12} className="mb-1">
                                            <strong>Recorrente:</strong> {recurringLabel}
                                          </Col>
                                          <Col xs={12}>
                                            <strong>Histórico:</strong> {record.history || '-'}
                                          </Col>
                                        </Row>
                                        {installmentInfo ? (
                                          <Row className="mt-1">
                                            <Col xs={12} className="mb-1">
                                              <strong>Parcela:</strong> {record.installment || '-'}
                                            </Col>
                                            <Col xs={12}>
                                              <strong>Valor Restante:</strong>{' '}
                                              <CurrencyFormat
                                                value={remainingValue}
                                                displayType={'text'}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                prefix="R$ "
                                              />
                                            </Col>
                                          </Row>
                                        ) : false}
                                        <Row className="mt-2">
                                          <Col xs={12} className="text-right">
                                            <RecordDelete item={record} />
                                          </Col>
                                        </Row>
                                      </Col>
                                    ) : false}
                                  </Row>
                                </Card.Body>
                              </Card>
                            )
                          })}
                        </div>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ))
        ) : (
          <Row>
            <Col>
              <Card>
                <Card.Body>Nenhuma previsão encontrada no período.</Card.Body>
              </Card>
            </Col>
          </Row>
        )}

          <Modal show={this.state.showSettle} onHide={this.handleCloseSettle} centered size="lg">
          <Modal.Header style={{ padding: '5px' }}>
            <Button.Group
              color={
                this.state.settleType === 'transfer'
                  ? 'green'
                  : this.state.settleRecord && this.state.settleRecord.type === 'D'
                    ? 'red'
                    : this.state.settleRecord && this.state.settleRecord.type === 'R'
                      ? 'blue'
                      : 'grey'
              }
              style={{ width: '100%' }}
            >
              <Button
                fluid
                icon
                labelPosition="left"
                size="small"
                onClick={this.handleCloseSettle}
              >
                <MDBIcon icon="check" className="mr-2" />
                Confirmar baixa
              </Button>
            </Button.Group>
          </Modal.Header>
          <Modal.Body style={{ padding: '7px' }}>
            <Card>
              <Card.Body>
                <Row>
                  <Col xs={12} md={6}>
                    <FormControl controlid="settleDate">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                      margin="normal"
                      id="date-picker-settle"
                      label="Data da baixa"
                      value={this.state.settleDate}
                      onChange={(e) => this.handleSettleDate(e)}
                      format="dd/MM/yyyy"
                      KeyboardButtonProps={{
                        'aria-label': 'Alterar Data',
                      }}
                      style={{ marginTop: '0px', width: '170px' }}
                    />
                  </MuiPickersUtilsProvider>
                </FormControl>
              </Col>
              <Col xs={12} md={6} className="text-right">
                <FormControl className="mt-2 previsions-settle-control" style={{ minWidth: '220px' }}>
                  <InputLabel id="settle-type-label">Tipo da baixa</InputLabel>
                  <Select
                    labelId="settle-type-label"
                    id="settle-type"
                    value={this.state.settleType}
                    onChange={this.handleSettleType}
                  >
                    <MenuItem value="normal">Normal</MenuItem>
                    <MenuItem value="transfer">Transferência</MenuItem>
                  </Select>
                </FormControl>
              </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <FormControl className="mt-2 w-100">
                      <InputLabel id="settle-account-label">
                        {this.state.settleType === 'transfer' ? 'Conta Destino' : 'Conta'}
                      </InputLabel>
                      <Select
                        labelId="settle-account-label"
                    id="settle-account"
                    value={this.state.settleAccount}
                    onChange={this.handleSettleAccount}
                  >
                    {settleAccountOptions.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        <div className="w-100">
                          <span>{item.name}</span>
                          <CurrencyFormat
                            value={item.balance}
                            displayType={'text'}
                            thousandSeparator="."
                            decimalSeparator=","
                            fixedDecimalScale={true}
                            decimalScale={2}
                            prefix="("
                            suffix=")"
                            className="float-right"
                          />
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                    </FormControl>
                  </Col>
                  {this.state.settleType === 'transfer' ? (
                    <Col xs={12} md={6}>
                      <FormControl className="mt-2 w-100">
                        <InputLabel id="settle-account-origin-label">Conta Origem</InputLabel>
                        <Select
                          labelId="settle-account-origin-label"
                          id="settle-account-origin"
                          value={this.state.settleAccountOrigin}
                          onChange={this.handleSettleAccountOrigin}
                        >
                          {settleAccountOptions.map((item) => (
                            <MenuItem key={item._id} value={item._id}>
                              <div className="w-100">
                                <span>{item.name}</span>
                                <CurrencyFormat
                                  value={item.balance}
                                  displayType={'text'}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                  prefix="("
                                  suffix=")"
                                  className="float-right"
                                />
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Col xs={12} md={8}>
                    <TextField
                      label="Histórico"
                      value={this.state.settleHistory}
                      onChange={this.handleSettleHistory}
                      fullWidth
                      className="mt-3"
                    />
                  </Col>
                  <Col xs={12} md={4} className="d-flex align-items-end">
                    <CurrencyFormat
                      label="Valor"
                      value={this.state.settleValue}
                      onValueChange={this.handleSettleValue}
                      thousandSeparator="."
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale={2}
                      prefix="R$ "
                      customInput={TextField}
                      fullWidth
                      className="mt-3"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button negative onClick={this.handleCloseSettle}>Cancelar</Button>
            <Button
              positive
              disabled={
                !this.state.settleRecord ||
                !!this.state.settlingIds[this.state.settleRecord._id] ||
                (this.state.settleType === 'transfer' &&
                  (!this.state.settleAccountOrigin ||
                    this.state.settleAccountOrigin === this.state.settleAccount))
              }
              onClick={() => this.settlePrevision(this.state.settleRecord._id)}
            >
              <Icon name="check" />
              Confirmar
            </Button>
          </Modal.Footer>
          </Modal>
        </Container>
      </>
    )
  }
}
